<template>
  <div class="empty-container">
    <div class="empty-title">{{ title }}信息更新中 敬请期待</div>
    <div class="empty-tips">先去其他城市看看吧~</div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '演唱会',
    },
  },
  data() {
    return {}
  },
  methods: {},
}
</script>
<style lang="less">
.empty-container {
  margin: 170px auto;
  text-align: center;
  font-family: HYYakuHei55W;
  color: #fff;
  .empty-title {
    display: inline-block;
    margin-bottom: 25px;
    text-align: center;
    font-weight: 850;
    font-size: 36px;
    padding: 35px 40px;
    background: #7640ff;
    border: 4px solid #000000;
    box-shadow: -10px -10px #000;
  }
  .empty-tips {
    font-size: 22px;
    line-height: 37px;
  }
}
</style>
